import { Badge, type BadgeVariant } from '../../../../components/ui/Badge/Badge';
import type { SkipJobStatus } from '../../../../types/api';

const STATUS_LABELS: Record<SkipJobStatus, string> = {
  new: 'New',
  in_progress: 'In Progress',
  delivered: 'Delivered',
  awaiting_collection: 'Awaiting Collection',
  collected: 'Collected',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

const STATUS_VARIANTS: Record<SkipJobStatus, BadgeVariant> = {
  new: 'info',
  in_progress: 'warning',
  delivered: 'success',
  awaiting_collection: 'warning',
  collected: 'info',
  completed: 'success',
  cancelled: 'muted',
};

export interface SkipJobStatusBadgeProps {
  status: SkipJobStatus;
}

export function SkipJobStatusBadge({ status }: SkipJobStatusBadgeProps): JSX.Element {
  return <Badge variant={STATUS_VARIANTS[status]}>{STATUS_LABELS[status]}</Badge>;
}
